import { UserName } from "pwapi";

import { USERS_LIST_SUCCESS } from "../actions/constants";

const reducer = (state: UserName[] = [], action: any): UserName[] => {
  switch (action.type) {
    case USERS_LIST_SUCCESS:
      return action.payload.results;
    default:
      return state;
  }
};

export default reducer;
